import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { tentativeCost } from "./tentative";

const TentativeCostForm = ({ onCancel }) => {
  const { getTentativeCost, addOrUpdateTentativeCost } = tentativeCost();
  const [formData, setFormData] = useState({
    basement_grey_structure_budget_sq_ft: "",
    grey_structure_budget_house_other_sq_ft: "",
    basement_grey_structure_good_sq_ft: "",
    grey_structure_good_house_other_sq_ft: "",
    budget_finishes_sq_ft: "",
    a_quality_finishes_sq_ft: "",
    premium_quality_finishes_sq_ft: "",
  });
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    getTentativeCost((data) => {
      setFormData(data);
      setInitialData(data);
    });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
      return;
    }
    if (initialData) {
      setFormData(initialData);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addOrUpdateTentativeCost(formData);
      setInitialData(formData);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Data has been successfully added!",
        confirmButtonText: "OK",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.message || "Failed to save tentative cost.",
      });
    }
  };

  return (
    <div>
      <div className="bg-gray-100 p-4 flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Tentative Cost</h2>
      </div>

      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-lg shadow-md max-w-5xl mx-auto"
      >
        <div className="grid grid-cols-2 gap-4">
          <label>
            Basement Grey Budget
            <input
              type="number"
              name="basement_grey_structure_budget_sq_ft"
              value={formData?.basement_grey_structure_budget_sq_ft}
              onChange={handleChange}
              className="border p-2 rounded w-full"
            />
          </label>
          <label>
            Grey Structure Budget House
            <input
              type="number"
              name="grey_structure_budget_house_other_sq_ft"
              value={formData?.grey_structure_budget_house_other_sq_ft}
              onChange={handleChange}
              className="border p-2 rounded w-full"
            />
          </label>
          <label>
            Basement Grey Good
            <input
              type="number"
              name="basement_grey_structure_good_sq_ft"
              value={formData?.basement_grey_structure_good_sq_ft}
              onChange={handleChange}
              className="border p-2 rounded w-full"
            />
          </label>
          <label>
            Grey Structure Good House
            <input
              type="number"
              name="grey_structure_good_house_other_sq_ft"
              value={formData?.grey_structure_good_house_other_sq_ft}
              onChange={handleChange}
              className="border p-2 rounded w-full"
            />
          </label>
          <label>
            Budget Finishes
            <input
              type="number"
              name="budget_finishes_sq_ft"
              value={formData?.budget_finishes_sq_ft}
              onChange={handleChange}
              className="border p-2 rounded w-full"
            />
          </label>
          <label>
            A Quality Finishes
            <input
              type="number"
              name="a_quality_finishes_sq_ft"
              value={formData?.a_quality_finishes_sq_ft}
              onChange={handleChange}
              className="border p-2 rounded w-full"
            />
          </label>
          <label className="col-span-2">
            Premium Quality Finishes
            <input
              type="number"
              name="premium_quality_finishes_sq_ft"
              value={formData?.premium_quality_finishes_sq_ft}
              onChange={handleChange}
              className="border p-2 rounded w-full"
            />
          </label>
        </div>
        <div className="flex justify-end gap-3 mt-6">
          <button
            type="button"
            onClick={handleCancel}
            className="btn btn-reset-filter justify-center"
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary justify-center">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default TentativeCostForm;
